<template>
    <v-menu
        v-model="fromDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        max-width="290px"
        min-width="290px"
        offset-y
        transition="scale-transition"
    >
        <template #activator="{ on }">
            <v-text-field v-model="fromDateVal" rounded readonly v-bind="$attrs" v-on="on"></v-text-field>
        </template>
        <v-date-picker v-model="fromDateVal" locale="en-in" no-title @input="fromDateMenu = false"></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    data: () => ({
        fromDateMenu: false,
        fromDateVal: null,
    }),
    watch: {
        fromDateVal(val) {
            this.fromDateVal = moment(val).format(this.$root.dateFormat);
        },
    },
};
</script>
